
<div class="touch">

  <div class="touch_header-detail">
    <h4 class="">
      <!-- <mat-icon class="note" *ngIf="touch.touchTypeName=='Note'">event_note</mat-icon>
      <mat-icon class="call" *ngIf="touch.touchTypeName=='Phone Call'">local_phone</mat-icon>
      <mat-icon class="email" *ngIf="touch.touchTypeName=='Email'">mail</mat-icon>
      <mat-icon class="meeting" *ngIf="touch.touchTypeName=='Meeting'">recent_actors</mat-icon>
      <mat-icon class="others" *ngIf="touch.touchTypeName=='Other'">add_to_photos</mat-icon>
      <mat-icon class="others" *ngIf="touch.touchTypeName=='Log'">text_snippet</mat-icon> -->
      <mat-icon>info</mat-icon>
  
      <span> {{touch.createdByFirstName|titlecase}} {{touch.createdByLastName|titlecase}}
        added {{touch.customNoteTypeName}} on {{touch.createdOn+'Z' | date:'MM/dd/yyyy'}} - {{touch.customNoteStatusName}}</span>
  
    </h4>
  
    <div class="timeStamp">
  
  
      <!-- <div class="time">
        <span *ngIf="touch.startDate != null"> {{touch.startDate+'Z' | date:'MM/dd/yyyy'}}</span>
        <span *ngIf="touch.touchDate != null"> {{touch.touchDate+'Z' | date:'MM/dd/yyyy'}}</span>
        <span *ngIf="touch.startTime != null || touch.touchTime != null" class="sep">-</span>
        <span *ngIf="touch.startTime != null"> {{touch.startTime | date:'h:mm a'}} </span>
        <span *ngIf="touch.touchTime != null"> {{touch.touchTime | date:'h:mm a'}} </span>
      </div> -->
  
  
  
  
    </div>
  
  </div>



    <div class="">
      <button mat-icon-button  [matMenuTriggerFor]="menu" color="primary" ><mat-icon>more_vert</mat-icon> </button>
      <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editCustomInfo(touch)" >Edit</button>
            <button mat-menu-item (click)="deleteCustomInfo(touch)">Delete</button> 
      </mat-menu>
    </div>

</div>

<div class="touch-note">
  <p [innerHTML]="touch.customNoteNew"></p>
</div>
<!-- <p  [innerHTML]="makeLinksClickable(touch.customNote)"></p> -->
<!-- <p class="touch_note">{{touch.customNote}}</p> -->
  <!-- <mat-icon *ngIf="touch.byPortal!=null && touch.viewOn==1" matTooltip="Added for Portal">call_made</mat-icon>
  <mat-icon *ngIf="touch.byPortal==null && touch.viewOn==1" matTooltip="Added from Portal">call_received</mat-icon> -->
